import { render, staticRenderFns } from "./BackdatingPosting.vue?vue&type=template&id=e7d0b3d2&"
import script from "./BackdatingPosting.vue?vue&type=script&lang=js&"
export * from "./BackdatingPosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports